import * as Sentry from "@sentry/nextjs";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { accountAtom } from "shared/lib/account/atoms";

export const useSentrySetup = () => {
  const { user } = useAtomValue(accountAtom);

  useEffect(() => {
    if (!user) return;
    const scope = Sentry.getCurrentScope();
    scope.setUser({
      ...user,
    });
    scope.addEventProcessor(event => {
      // Avoid sending bunch of events if the user is not from internal
      // This is a workaround for changing the sample rate dynamically
      if (Math.random() < 0.001 || user.useremail.includes("@scmp.com")) return event;
      return null;
    });
  }, [user]);
};
